import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA, Injectable } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxPermissionsModule } from "ngx-permissions";

import { ToastrModule } from "ngx-toastr";
import { SharedModule } from "./shared/shared.module";
import { ToastOptions } from "./constants";
import { CoreModule } from "./core/core.module";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
  HttpErrorResponse
} from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  TranslateModule,
  TranslateLoader
} from "@ngx-translate/core";
// Import your library
import { AppRoutesModule } from "./app.routes";
import { AppComponent } from "./app.component";
// import { GlobalErrorHandler } from "./shared/error-handler/global-error-handler";
import { LocalStorageService } from "./shared/services/local-storage.service";
import { HttpConfigInterceptor } from "./shared/services/http-interceptor.service";
import { NgSelectModule } from "@ng-select/ng-select";

// declare gtag as a function to set and sent the events
declare let gtag: Function;

// Our service to handle errors (ideally in its own file)
@Injectable({
  providedIn: 'root'
})
export class ErrorLogService {
  private name: String = 'ErrorLogService';
  logError(error: any) {
    let errLog: string;
    if (error instanceof HttpErrorResponse) {
      errLog = 'There was an HTTP error.' + 'Status code:' + (<HttpErrorResponse>error).status + JSON.stringify(error.message);
    } else if (error instanceof TypeError) {
      errLog = 'There was a Type error - ' + JSON.stringify(error.message);
    } else if (error instanceof Error) {
      errLog = 'There was a general error - ' + JSON.stringify(error.message);
    } else {
      errLog = 'Nobody threw an error but something happened! - ' + JSON.stringify(error);
    }
    gtag('event', 'exception', {
      'description': errLog,
      'fatal': false
    });
  }
}

// global error handler that utilizes the above created service (ideally in its own file)

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private errorLogService: ErrorLogService) {
    super();
  }
  handleError(error) {
    super.handleError(error);
    this.errorLogService.logError(error);
  }
}

// declare var require: any;
// AoT requires an exported function for factories
export function customHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    NgSelectModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    ToastrModule.forRoot(ToastOptions),
    AppRoutesModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: customHttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    Title,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    LocalStorageService],
  // providers: [Title, { useClass: GlobalErrorHandler, provide: ErrorHandler }],
  bootstrap: [AppComponent]
})
export class AppModule { }
